module.exports = __webpack_public_path__ + "static/media/cp-pelican1.cde38719.jpg";